import { NominationPermissions } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getNominationPermissions: (
  fetchContext: FetchContext,
  nominationId: number,
  accessToken?: string,
) => Promise<NominationPermissions> = (fetchContext, nominationId, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/nominations/${nominationId}/permissions`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<NominationPermissions>(fetchContext.errorStore, response, 'get nomination permissions'));
